import { handleResponse } from '../../Helpers/handle-response';
import * as apiHelper from '../../Helpers/apiHelper';

// SC: GET User permissions
export function getPermissionsByUser(userid) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };    
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPERMISSIONSBYUSER);
    url += `?id=${userid}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getCompetencesByUser(userid) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };    
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETCOMPETENCESBYUSER);
    url += `?id=${userid}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getAllUsersWithDetails() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };    
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLUSERSWITHDETAILS);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getAllRoles() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };    
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLROLES);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function saveUser(user) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify(user)
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SAVEUSER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getUserById(userid) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };    
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETUSERBYID);
    url += `?userId=${userid}`;
    
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function sendValidateUser(userName, password) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            LoginName:userName,
            Password:password
          })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_VALIDATEUSER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}





